/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerFacebookDestinationComponent', [
    'DesignerBaseSourceAndDestinationComponent',
    'DesignerConnection',

    function (DesignerBaseSourceAndDestinationComponent, DesignerConnection) {
      function DesignerFacebookDestinationComponent() {
        DesignerBaseSourceAndDestinationComponent.apply(this);

        this.object_name = null;
        this.operation_type = null;
        this.batch_size = null;
        this.max_errors = null;
        this.column_mappings = [];
        this.cloud_storage_connection_id = null;
      }

      DesignerFacebookDestinationComponent.prototype = new DesignerBaseSourceAndDestinationComponent();

      DesignerFacebookDestinationComponent.prototype.getData = function () {
        const data = DesignerBaseSourceAndDestinationComponent.prototype.getData.call(this);

        _.extend(data, {
          cloud_storage_connection_id: String(this.connection.id || ''),
          object_name: this.object_name || this.defaults.object_name,
          operation_type: this.operation_type || this.defaults.operation_type,
          batch_size: this.batch_size || this.defaults.batch_size,
          max_errors: this.max_errors || this.defaults.max_errors,
          account_id: this.account_id || this.defaults.account_id,
          column_mappings: this.column_mappings || this.defaults.column_mappings,
        });

        return data;
      };

      DesignerFacebookDestinationComponent.prototype.getFormData = function () {
        return DesignerBaseSourceAndDestinationComponent.prototype.getFormData.call(this);
      };

      DesignerFacebookDestinationComponent.prototype.setFormData = function (data) {
        DesignerBaseSourceAndDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerFacebookDestinationComponent.prototype.setData = function (data) {
        this.cloud_storage_connection_id = String(this.connection.id || '');
        this.object_name = data.object_name;
        this.operation_type = data.operation_type;
        this.account_id = data.account_id;
        this.batch_size = Number(data.batch_size);
        this.max_errors = Number(data.max_errors);
        this.column_mappings = data.column_mappings;

        DesignerBaseSourceAndDestinationComponent.prototype.setData.call(this, data);
      };

      DesignerFacebookDestinationComponent.prototype.getSchema = function () {
        return DesignerBaseSourceAndDestinationComponent.prototype.getSchema.call(this);
      };

      return DesignerFacebookDestinationComponent;
    },
  ]);
})(window.angular);
